// This component is First tab of Application form // To get basic contact and
address details
<template>
  <div class="bg-gray-50 shadow px-4 py-5 sm:rounded sm:p-6" v-bind:class="{ 'model-open': showDeleteModal }">
    <div class="md:grid md:grid-cols-2 md:gap-6 sm:px-6">
      <div class="md:col-span-1">
        <h3 class="text-lg font-sans font-medium leading-6 text-gray-900">
          PRIMARY DETAILS
        </h3>
        <p class="mt-1 text-sm text-gray-500">
          Please enter your name, contact(s) information, and address(es) as you
          wish them to appear in our attorney directory.
        </p>
      </div>
      <div class="mt-5 md:mt-0 md:col-span-2">
        <form @submit.prevent="submitApplication" novalidate class="space-y-6">
          <div class="col-span-6 sm:col-span-3">
            <div class="shadow sm:rounded-md sm:overflow-hidden 2">
              <div class="bg-white py-6 px-4 space-y-6 sm:p-6">
                <div class="grid xl:grid-cols-6 grid-cols-2 xl:gap-4 gap-3">
                  <div class="col-span-6 sm:col-span-1">
                    <label class="block text-sm font-medium text-gray-900" for="salutation">Salutation
                    </label>
                    <select
                      id="salutation"
                      class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm"
                      :class="{ 'border-red-400': v$.form.salutation.$error }"
                      :value="form.salutation?.name || form.salutation || ''"
                      @change="onSalutationChange"
                    >
                      <option value="">Select</option>
                      <option
                        v-for="item in salutations"
                        :key="item.id"
                        :value="item.name"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-span-6 sm:col-span-2">
                    <text-input label="First Name" :class="{ 'border-red-400': v$.form.first_name.$error }"
                      v-bind:value="form.first_name" id="first_name" :required="true"
                      v-on:keyup="form.first_name = $event.target['value']"
                      helptext="Enter your first name"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.first_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <text-input label="Middle Name" v-bind:value="form.middle_name" id="middle_name"
                      :class="{ 'border-red-400': v$.form.middle_name.$error }"
                      v-on:keyup="form.middle_name = $event.target['value']"
                      helptext="Middle name or initails"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.middle_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-2">
                    <text-input label="Last Name" :required="true"
                      :class="{ 'border-red-400': v$.form.last_name.$error }" v-bind:value="form.last_name"
                      id="last_name" v-on:keyup="form.last_name = $event.target['value']"
                      helptext="Enter your last name"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.last_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-3">
                    <text-input label="Name of Firm" :class="{ 'border-red-400': v$.form.firm_name.$error }"
                      v-bind:value="form.firm_name" id="firm_name"
                      v-on:keyup="form.firm_name = $event.target['value']"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.firm_name.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                  <div class="col-span-6 sm:col-span-1">
                    <text-input label="Office Hours" type="text"
                      :class="{ 'border-red-400': v$.form.office_hours.$error }" v-bind:value="form.office_hours"
                      id="office_hours" v-on:keyup="form.office_hours = $event.target['value']"></text-input>
                    <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.office_hours.$errors"
                      :key="index">
                      <div v-if="error.$validator == 'required'">
                        {{ error.$message }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="contacts-block contacts-block--attorney">
                  <div
                    v-for="(contact, i) in form.contacts"
                    :key="i"
                    class="contact-card"
                    :class="{ 'contact-card--first': getContactType(contact) === 'Primary' }"
                  >
                    <div class="contact-card__header">
                      <span class="contact-card__title">{{ getContactCardTitle(contact, i) }}</span>
                      <div class="contact-card__toolbar">
                        <button
                          v-if="i === 0"
                          type="button"
                          class="contact-action-btn contact-action-btn--add"
                          title="Add contact"
                          aria-label="Add contact"
                          @click="add_contact()"
                        >
                          +
                        </button>
                        <button
                          v-else
                          type="button"
                          class="contact-action-btn contact-action-btn--remove"
                          title="Remove contact"
                          aria-label="Remove contact"
                          @click="ConfirmContactDelete(i)"
                        >
                          -
                        </button>
                      </div>
                    </div>
                    <div
                      v-if="isPrimaryContactEmailLocked(contact)"
                      class="contact-card__notice"
                    >
                      <span class="contact-required-mark" aria-hidden="true">*</span>
                      If you need to update your primary email, please contact U.S. Legal Services
                      Provider Relations at
                      <a href="tel:18448945297" class="contact-card__notice-link">1-844-894-LAWS (5297)</a>.
                    </div>
                    <div class="contact-card__body">
                      <div class="grid grid-cols-12 gap-x-4 contact-card__row contact-card__row--primary-fields">
                        <div class="col-span-12 sm:col-span-4 md:col-span-3 contact-field">
                          <label
                            class="contact-field-label contact-field-label--required"
                            :for="'attorney-contact-category-' + i"
                          >
                            Type<span class="contact-required-mark" aria-hidden="true">*</span>
                          </label>
                          <select
                            :id="'attorney-contact-category-' + i"
                            v-model="contact.type"
                            class="form-control contact-category-select contact-glass-field block w-full"
                            :class="[
                              getContactCategorySelectClasses(contact, i),
                              { 'border-red-400': contactCategoryErrors[i] },
                            ]"
                            aria-required="true"
                            @change="onContactTypeChange(contact, i)"
                          >
                            <option value="">Select Type</option>
                            <option
                              v-if="
                                contact.type &&
                                attorneyContactTypeOptions.indexOf(contact.type) === -1
                              "
                              :value="contact.type"
                            >
                              {{ contact.type }}
                            </option>
                            <option
                              v-if="!isPrimaryTaken(i) || getContactType(contact) === 'Primary'"
                              value="Primary"
                            >
                              Primary
                            </option>
                            <option
                              v-else
                              value=""
                              disabled
                            >
                              Primary — already used (disabled)
                            </option>
                            <option
                              v-for="option in secondaryContactTypeOptions"
                              :key="option"
                              :value="option"
                            >
                              {{ option }}
                            </option>
                          </select>
                          <small
                            v-if="getContactType(contact) === 'Primary' && isPrimaryTaken(i)"
                            class="contact-category-disabled-hint"
                          >
                            Primary is already used on another contact.
                          </small>
                          <p v-if="contactCategoryErrors[i]" class="text-red-600 mt-1 text-sm">
                            {{ contactCategoryErrors[i] }}
                          </p>
                        </div>
                        <div class="col-span-12 sm:col-span-8 md:col-span-9 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-name-' + i">
                            Name<span
                              v-if="isPrimaryContact(contact)"
                              class="contact-required-mark"
                              aria-hidden="true"
                            >*</span>
                          </label>
                          <input
                            :id="'attorney-contact-name-' + i"
                            type="text"
                            class="form-control contact-input block w-full"
                            :class="{ 'border-red-400': v$.form.contacts[i]?.name.$error }"
                            :aria-required="isPrimaryContact(contact) ? 'true' : undefined"
                            :value="contact.name"
                            @keyup="contact.name = $event.target.value"
                          />
                          <div
                            class="text-red-600 mt-1 text-sm"
                            v-for="(error, index) in v$.form.contacts[i]?.name.$errors"
                            :key="index"
                          >
                            <div v-if="error.$validator == 'required'">
                              {{ error.$message }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="grid grid-cols-12 gap-x-4 contact-card__row contact-card__row--details">
                        <div class="col-span-12 sm:col-span-6 md:col-span-4 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-email-' + i">
                            Email<span
                              v-if="isPrimaryContact(contact)"
                              class="contact-required-mark"
                              aria-hidden="true"
                            >*</span>
                          </label>
                          <input
                            :id="'attorney-contact-email-' + i"
                            type="text"
                            class="form-control contact-input block w-full"
                            placeholder="Email"
                            :readonly="isPrimaryContactEmailLocked(contact)"
                            :aria-readonly="isPrimaryContactEmailLocked(contact) ? 'true' : undefined"
                            :aria-required="isPrimaryContact(contact) ? 'true' : undefined"
                            :class="{ 'border-red-400': v$.form.contacts[i]?.email.$error }"
                            :value="contact.email"
                            @keyup="!isPrimaryContactEmailLocked(contact) && (contact.email = $event.target.value)"
                          />
                          <div
                            class="text-red-600 mt-1 text-sm"
                            v-for="(error, index) in v$.form.contacts[i]?.email.$errors"
                            :key="index"
                          >
                            <div v-if="error.$validator == 'required'">
                              {{ error.$message }}
                            </div>
                            <div v-if="error.$validator == 'email' || error.$validator == 'regex'">
                              Please enter valid email
                            </div>
                          </div>
                        </div>
                        <div class="col-span-6 md:col-span-2 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-phone-' + i">
                            Telephone<span
                              v-if="isPrimaryContact(contact)"
                              class="contact-required-mark"
                              aria-hidden="true"
                            >*</span>
                          </label>
                          <InputMask
                            :id="'attorney-contact-phone-' + i"
                            mask="(999)999-9999"
                            class="form-control contact-input block w-full"
                            placeholder="(111) 222-3333"
                            :aria-required="isPrimaryContact(contact) ? 'true' : undefined"
                            :class="{ 'border-red-400': v$.form.contacts[i]?.phone.$error }"
                            v-model="contact.phone"
                          />
                          <div
                            class="text-red-600 mt-1 text-sm"
                            v-for="(error, index) in v$.form.contacts[i]?.phone.$errors"
                            :key="index"
                          >
                            <div v-if="error.$validator == 'required'">
                              {{ error.$message }}
                            </div>
                          </div>
                        </div>
                        <div class="col-span-6 md:col-span-2 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-cell-' + i">Cell Phone</label>
                          <InputMask
                            :id="'attorney-contact-cell-' + i"
                            mask="(999)999-9999"
                            class="form-control contact-input block w-full"
                            placeholder="(111) 222-3333"
                            :class="{ 'border-red-400': v$.form.contacts[i]?.cell.$error }"
                            v-model="contact.cell"
                          />
                        </div>
                        <div class="col-span-6 md:col-span-2 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-ext-' + i">Ext</label>
                          <input
                            :id="'attorney-contact-ext-' + i"
                            type="text"
                            class="form-control contact-input block w-full"
                            placeholder="Ext"
                            :class="{ 'border-red-400': v$.form.contacts[i]?.ext.$error }"
                            :value="contact.ext"
                            @keyup="contact.ext = $event.target.value"
                          />
                        </div>
                        <div class="col-span-6 md:col-span-2 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-fax-' + i">Fax</label>
                          <input
                            :id="'attorney-contact-fax-' + i"
                            type="text"
                            class="form-control contact-input block w-full"
                            placeholder="Fax"
                            :class="{ 'border-red-400': v$.form.contacts[i]?.fax.$error }"
                            :value="contact.fax"
                            @keyup="contact.fax = $event.target.value"
                          />
                        </div>
                        <div class="col-span-6 md:col-span-2 contact-field">
                          <label class="contact-field-label" :for="'attorney-contact-note-' + i">Note</label>
                          <input
                            :id="'attorney-contact-note-' + i"
                            type="text"
                            class="form-control contact-input contact-glass-field block w-full"
                            :placeholder="i === 0 ? 'Note' : 'Office, Work, etc.'"
                            :value="contact.note"
                            @keyup="contact.note = $event.target.value"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END PRIMARY CONTACT SECTION -->
                <div class="" v-for="(address, ind) in form.addresses" :key="ind">
                  <!-- START PRIMARY ADDRESS SECTION -->
                  <div
                    class="flex flex-col sm:flex-row cobalt-bg-color sm:items-center sm:justify-between gap-2"
                    v-if="ind == 0"
                  >
                    <div class="m-4 mb-0 sm:mb-4">
                      <h3 class="text-lg leading-6 font-medium text-[#1f3341]">
                        Primary Address
                      </h3>
                    </div>

                    <div class="mx-4 mb-4 sm:mb-0 sm:mr-4 flex-shrink-0 w-auto">
                      <button type="button" @click="add_address()"
                        class="relative inline-flex items-center justify-center w-full sm:w-auto px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white barley-btn focus:outline-none focus:ring-2 focus:ring-offset-2">
                        + Add Address
                      </button>
                    </div>
                  </div>
                  <div
                    class="flex flex-col sm:flex-row cobalt-bg-color sm:items-center sm:justify-between gap-2"
                    v-if="ind != 0"
                  >
                    <div class="m-4 mb-0 sm:mb-4">
                      <h3 class="text-lg leading-6 font-medium text-[#1f3341]">
                        Secondary Address
                      </h3>
                    </div>

                    <div class="mx-4 mb-4 sm:mb-0 sm:mr-4 flex-shrink-0 w-auto">
                      <button type="button" @click="ConfirmDelete(ind)"
                        class="relative inline-flex items-center justify-center w-full sm:w-auto px-2.5 py-1.5 border border-transparent text-xs font-medium rounded shadow-sm text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500">
                        + Remove Address
                      </button>
                    </div>
                  </div>
                  <div>
                    <div class="form-group grid xl:grid-cols-6 grid-cols-1 xl:gap-6 gap-0 mt-2">
                      <div class="col-span-6 sm:col-span-1">
                        <label class="block text-sm font-medium text-gray-900 mt-2" :for="'address_type_' + ind">Address Type <span
                            class="text-red-700">*</span>
                        </label>
                        <div class="form-group mt-1" v-if="ind == 0">
                          <select
                            :id="'address_type_' + ind"
                            class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm bg-gray-100"
                            disabled
                            :value="address.type?.name || address.type || 'PRIMARY'"
                          >
                            <option
                              v-for="item in infoTypes"
                              :key="item.id"
                              :value="item.name"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group mt-2" v-if="ind != 0">
                          <select
                            :id="'address_type_' + ind"
                            class="mt-1 block w-full h-10 border border-barley rounded-sm shadow-sm py-2 px-3 focus:outline-none sm:text-sm bg-gray-100"
                            :class="{
                              'border-red-400':
                                v$.form.addresses[ind]?.type.$error,
                            }"
                            disabled
                            :value="address.type?.name || address.type || 'SECONDARY'"
                          >
                            <option
                              v-for="item in infoTypes"
                              :key="item.id"
                              :value="item.name"
                            >
                              {{ item.name }}
                            </option>
                          </select>
                          <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.type
                            .$errors" :key="index">
                            <div v-if="error.$validator == 'required'">
                              {{ error.$message }}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="form-group mt-2 col-span-6 sm:col-span-3">
                        <label class="block text-sm font-medium text-gray-900" :for="'address_' + ind">Address (line
                          1) <span class="text-red-700">*</span>
                        </label>
                        <vue-google-autocomplete v-if="mapsLoaded" class="mt-1" :id="'address_' + ind" :ref="'address_' + ind"
                          types="address" :class="{
                            'border-red-400':
                              v$.form.addresses[ind]?.address1.$error,
                          }" v-model="address.address1"
                          classname="w-full text-black border border-barley rounded py-2 px-4 mb-3" v-on:placechanged="
                            getAddressData($event, 'address1', ind)
                            ">
                        </vue-google-autocomplete>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]
                          ?.address1.$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>

                      <div class="form-group mt-2 col-span-6 sm:col-span-2">
                        <text-input :id="'address2' + ind" label="Address (line 2)" v-bind:value="address.address2"
                          v-on:keyup="address.address2 = $event.target['value']"></text-input>
                      </div>
                    </div>

                    <div class="form-group grid xl:grid-cols-6 grid-cols-2 xl:gap-6 gap-2 mt-2">
                      <!-- city -->
                      <div class="col-span-6 sm:col-span-1">
                        <text-input :id="'city' + ind" label="City" :required="true" :class="{
                          'border-red-400': v$.form.addresses[ind]?.city.$error,
                        }" v-bind:value="address.city"
                          v-on:keyup="address.city = $event.target['value']"></text-input>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.city
                          .$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>

                      <div class="col-span-6 sm:col-span-1">
                        <text-input label="State" :id="'state' + ind" :required="true" :class="{
                          'border-red-400':
                            v$.form.addresses[ind]?.state.$error,
                        }" v-bind:value="address.state"
                          v-on:keyup="address.state = $event.target['value']"></text-input>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.state
                          .$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>
                      <div class="col-span-6 sm:col-span-1">
                        <text-input :id="'country' + ind" label="Country" v-bind:value="address.country"
                          v-on:keyup="address.country = $event.target['value']"></text-input>
                      </div>
                      <div class="col-span-6 sm:col-span-1">
                        <text-input label="Zip" :id="'zip' + ind" :required="true" @change="getCountry(ind)" :class="{
                          'border-red-400': v$.form.addresses[ind]?.zip.$error,
                        }" v-bind:value="address.zip" v-on:keyup="address.zip = $event.target['value']">
                        </text-input>
                        <div class="text-red-600 mt-1 text-sm" v-for="(error, index) in v$.form.addresses[ind]?.zip
                          .$errors" :key="index">
                          <div v-if="error.$validator == 'required'">
                            {{ error.$message }}
                          </div>
                        </div>
                      </div>

                      <div class="col-span-6 sm:col-span-1">
                        <text-input :id="'county' + ind" label="County" disabled v-bind:value="address.county"
                          v-on:keyup="address.county = $event.target['value']"></text-input>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- END PRIMARY ADDRESS SECTION -->
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <confirm-popup :showDeleteModal="showDeleteModal" title="Delete" short_msg="Are you sure?"
      msg=" Do you really want to delete this address? This process cannot be undone." @click="cancelModal()"
      @remove="remove_address()"></confirm-popup>

    <confirm-popup :showDeleteModal="showContactDeleteModal" title="Delete" short_msg="Are you sure?"
      msg=" Do you really want to delete this contact? This process cannot be undone." @click="cancelModal()"
      @remove="remove_contact()"></confirm-popup>
  </div>
</template>
<script>
import { loadGoogleMaps } from "../../utils/loadGoogleMaps";
import VueGoogleAutocomplete from "vue-google-autocomplete"; //For address autocomplete from google
import TextInput from "../Layout/Form/TextInput.vue"; //reusable Input field
import ConfirmPopup from "../Layout/Modals/ConfirmPopup.vue"; // resuable delete confirm popup
import useVuelidate from "@vuelidate/core";
import { required, helpers } from "@vuelidate/validators";

const emailValidator = helpers.withMessage(
  "Please enter valid email",
  helpers.regex(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
);
import InputMask from "primevue/inputmask";
import { mapState } from "vuex";
import moment from "moment-timezone";
import {
  ATTORNEY_CONTACT_TYPE_OPTIONS,
  createEmptyContact,
  getContactCardTitle,
  getContactCategorySelectClasses,
  getContactType,
  isAttorneyPrimaryCategoryTaken,
  isPrimaryContact,
  isPrimaryContactEmailLocked,
  normalizeContactsForForm,
  onAttorneyContactCategoryChange,
  prepareContactsForSave,
  sortContactsPrimaryFirst,
  stampPrimaryContactOldEmails,
  validateAttorneyContactCategories,
} from "../../utils/contactHelpers.js";

export default {
  name: "AppPrimary",
  setup() {
    return {
      v$: useVuelidate(),
    };
  },
  props: ["forms"],
  data: function () {
    // Static variables for this component
    return {
      mapsLoaded: false,
      form: this.forms,
      sizes: ["lg", "md", "sm"],
      showDeleteModal: false,
      showContactDeleteModal: false,
      deleteIndex: "",
      deleteContactIndex: "",
      contactCategoryErrors: {},
      attorneyContactTypeOptions: ATTORNEY_CONTACT_TYPE_OPTIONS,
      salutations: [
        { id: 0, name: "Mr" },
        { id: 1, name: "Mrs" },
        { id: 2, name: "MS" },
      ],
      attorney_types: [
        { id: "FAM", name: "Family Defender (FAM)" },
        { id: "CDL", name: "CDL Defender (CDL)" },
        { id: "REF", name: "Referral (REF)" },
      ],
      infoTypes: [
        { id: 0, name: "PRIMARY" },
        { id: 1, name: "SECONDARY" },
      ],
    };
  },
  validations() {
    //For Dynamic Validation based on Dynamic form fields
    let addresses = [];
    let contacts = [];
    for (let index = 0; index < this.form?.addresses?.length; index++) {
      addresses.push({
        type: { required },
        address1: { required },
        city: { required },
        state: { required },
        zip: { required },
      });
    }
    for (let index = 0; index < this.form?.contacts?.length; index++) {
      const contact = this.form.contacts[index];
      if (isPrimaryContact(contact)) {
        contacts.push({
          email: { required, emailValidator },
          name: { required },
          fax: {},
          cell: {},
          phone: { required },
          ext: {},
        });
      } else {
        contacts.push({
          email: { emailValidator },
          name: {},
          fax: {},
          cell: {},
          phone: {},
          ext: {},
        });
      }
    }
    return {
      form: {
        first_name: { required },
        last_name: { required },
        middle_name: {},
        office_hours: {},
        salutation: {},
        firm_name: {},
        addresses: addresses,
        contacts: contacts,
      },
    };
  },
  components: {
    VueGoogleAutocomplete,
    TextInput,
    ConfirmPopup,
    InputMask,
  },
  async mounted() {
    try {
      await loadGoogleMaps();
    } catch(e) { console.error('Error loading Google Maps:', e); }

    this.mapsLoaded = true;
    await this.$nextTick();
    this.ensureDefaultContactTypes();

    if (!this.att_user?.data || this.att_user == undefined) {
      let Data = this.leadData.result.lead[0];
      this.form.lead_id = Data.id;
      if (!this.tempAttData.is_attorney_exist) {
        this.form.first_name = Data.firstname;
        this.form.last_name = Data.lastname;
        setTimeout(() => {
          this.form.emailAddress = Data.email; // HubSpot uses `email`
          this.$nextTick(() => {
              this.form.addresses[0].address1 = Data.address; // keep form in sync
                      document.getElementById("address_0").value = Data.address;
          });

          this.form.addresses[0].city = Data.city;
          const stateMap = {
            "Alabama": "AL",
            "Alaska": "AK",
            "Arizona": "AZ",
            "Arkansas": "AR",
            "California": "CA",
            "Colorado": "CO",
            "Connecticut": "CT",
            "Delaware": "DE",
            "Florida": "FL",
            "Georgia": "GA",
            "Hawaii": "HI",
            "Idaho": "ID",
            "Illinois": "IL",
            "Indiana": "IN",
            "Iowa": "IA",
            "Kansas": "KS",
            "Kentucky": "KY",
            "Louisiana": "LA",
            "Maine": "ME",
            "Maryland": "MD",
            "Massachusetts": "MA",
            "Michigan": "MI",
            "Minnesota": "MN",
            "Mississippi": "MS",
            "Missouri": "MO",
            "Montana": "MT",
            "Nebraska": "NE",
            "Nevada": "NV",
            "New Hampshire": "NH",
            "New Jersey": "NJ",
            "New Mexico": "NM",
            "New York": "NY",
            "North Carolina": "NC",
            "North Dakota": "ND",
            "Ohio": "OH",
            "Oklahoma": "OK",
            "Oregon": "OR",
            "Pennsylvania": "PA",
            "Rhode Island": "RI",
            "South Carolina": "SC",
            "South Dakota": "SD",
            "Tennessee": "TN",
            "Texas": "TX",
            "Utah": "UT",
            "Vermont": "VT",
            "Virginia": "VA",
            "Washington": "WA",
            "West Virginia": "WV",
            "Wisconsin": "WI",
            "Wyoming": "WY"
          };
    this.$nextTick(() => {
  const ref = this.$refs["address_0"];
  if (ref) {
    // If it's an array (v-for), take first element
    const autocompleteComponent = Array.isArray(ref) ? ref[0] : ref;
      autocompleteComponent.update(this.form.addresses[0].address1);
  }
});

          // Convert full state name from HubSpot to abbreviation
          const stateShort = stateMap[Data.state] || Data.state;

          // Now set in your form
          this.form.addresses[0].state = stateShort;

          this.form.addresses[0].zip = Data.zip;
          this.form.addresses[0].country = Data.country;

          this.form.contacts[0].name = Data.firstname + " " + Data.lastname;
          this.form.contacts[0].type = "Primary";
          this.form.contacts[0].fax = Data.fax;

          if (Data.phone != "" && Data.phone != null) {
            this.form.contacts[0].phone = this.formatPhoneUS(Data.phone);
          }
          if (Data.mobilephone != "" && Data.mobilephone != null) {
            this.form.contacts[0].cell = this.formatPhoneUS(Data.mobilephone);
          }

          // phone extension is not default in HubSpot → must create a custom field
          this.form.contacts[0].ext = Data.phoneNumberExtension || "";

          this.form.contacts[0].email = Data.email;
        });
      } else {
        for (let index = 0; index < this.form?.addresses?.length; index++) {
          this.$nextTick(() => {
            const refObj = this.$refs["address_" + index];
            if (refObj) {
              const autocompleteComponent = Array.isArray(refObj) ? refObj[0] : refObj;
              if (autocompleteComponent && typeof autocompleteComponent.update === "function") {
                autocompleteComponent.update(this.form.addresses[index].address1);
              }
            }
          });
        }
      }
      let keys = Object.keys(Data);
      this.form.lead.hs_object_id = Data.id;
      keys.forEach((key) => {
        var currentDate = new Date();
        currentDate = moment(currentDate).tz("US/Eastern").format("YYYY-MM-DD");
        if (key.includes("attorney_join_or_decline") || key.includes("did_attorney_join_or_decline_")) {
          this.form.lead[key] = "Joined";
        }
        if (key.includes("attorney_status_in_member_system")) {
          this.form.lead[key] = "Pending";
        }
        if (key.includes("date_joined_or_declined_")) {
          this.form.lead[key] = currentDate;
        }
        if (key.includes("date_application_received_by_usl_")) {
          this.form.lead[key] = currentDate;
        }
        if (
          key.includes("family_defender_attorney_") &&
          !key.includes("family_defender_attorney_application_requested_")
        ) {
          if (Data[key] != "" && Data[key] != null && Data[key] == "Yes") {
            this.form.attorney_type.push("FAM");
          }
        }
        if (
          key.includes("referral_attorney_") ||
          key.includes("contingent_fee_attorney_") ||
          key.includes("discounted_rate_attorney_")
        ) {
          if (Data[key] != "" && Data[key] != null && Data[key] == "Yes") {
            this.form.attorney_type.push("REF");
          }
        }
        if (
          key.includes("cdl_attorney_") ||
          key.includes("family_defender_attorney_application_requested_")
        ) {
          if (Data[key] != "" && Data[key] != null && Data[key] == "Yes") {
            this.form.attorney_type.push("CDL");
          }
        }
      });
    } else {
      for (let index = 0; index < this.form?.addresses?.length; index++) {
        setTimeout(() => {
          const el = document.getElementById("address_" + index);
          if (el) el.value = this.form.addresses[index].address1;
          const refObj = this.$refs["address_" + index];
          if (refObj) {
            const autocompleteComponent = Array.isArray(refObj) ? refObj[0] : refObj;
            if (autocompleteComponent && typeof autocompleteComponent.update === "function") {
              autocompleteComponent.update(this.form.addresses[index].address1);
            }
          }
        }, 1000);
      }
    }
    if (this.att_user?.data && this.profile_data) {
      this.syncFormFromProfile();
    }
  },
  //to fetch variable data from central store

  computed: {
    ...mapState([
      "leadData",
      "att_user",
      "profile_data",
      "address_county",
      "tempAttData",
    ]),
    secondaryContactTypeOptions() {
      return this.attorneyContactTypeOptions.filter((type) => type !== "Primary");
    },
  },
  created() {
    this.$store.watch(
      () => this.$store.state.profile_data,
      (value) => {
        if (value != null) {
          if (this.att_user?.data && this.att_user != undefined) {
            this.syncFormFromProfile();
          }
        }
      }
    );
  },
  methods: {
    getContactType,
    isPrimaryContact,
    getContactCardTitle,
    getContactCategorySelectClasses(contact, index) {
      return getContactCategorySelectClasses(
        contact,
        this.form.contacts,
        index
      );
    },
    isPrimaryTaken(index) {
      return isAttorneyPrimaryCategoryTaken(this.form.contacts, index);
    },
    isPrimaryContactEmailLocked,
    stampPrimaryContactOldEmails,
    ensureDefaultContactTypes() {
      if (!this.form.contacts?.length) {
        this.form.contacts = [createEmptyContact("Primary")];
      }
      if (!getContactType(this.form.contacts[0])) {
        this.form.contacts[0].type = "Primary";
      }
      this.form.contacts = sortContactsPrimaryFirst(this.form.contacts);
    },
    syncFormFromProfile() {
      if (!this.profile_data) {
        return;
      }
      this.form.contacts = normalizeContactsForForm(
        this.profile_data?.contacts || []
      );
      this.stampPrimaryContactOldEmails(this.form.contacts);
      this.form.addresses = this.profile_data?.addresses || [];
      for (let index = 0; index < this.form?.addresses?.length; index++) {
        if (typeof this.form.addresses[index].type != "object") {
          if (
            this.form.addresses[index].type == "PRIMARY" ||
            this.form.addresses[index].type == "Primary"
          ) {
            this.form.addresses[index].type = { id: 0, name: "PRIMARY" };
          } else {
            this.form.addresses[index].type = {
              id: 1,
              name: this.form.addresses[index].type,
            };
          }

          setTimeout(() => {
            const refObj = this.$refs["address_" + index];
            if (refObj) {
              const autocompleteComponent = Array.isArray(refObj)
                ? refObj[0]
                : refObj;
              if (
                autocompleteComponent &&
                typeof autocompleteComponent.update === "function"
              ) {
                autocompleteComponent.update(
                  this.form.addresses[index].address1
                );
              }
            }
          }, 100);
        }
      }
      this.form.id = this.profile_data?.id;
      this.form.first_name = this.profile_data?.first_name;
      this.form.last_name = this.profile_data?.last_name;
      this.form.middle_name = this.profile_data?.middle_name;
      this.form.firm_name = this.profile_data?.firm_name;
      this.form.office_hours = this.profile_data?.office_hours;
      this.salutations.forEach((element) => {
        if (element.name == this.profile_data?.salutation) {
          this.form.salutation = element;
        }
      });

      if (typeof this.profile_data?.attorney_type == "string") {
        this.form.attorney_type = this.profile_data?.attorney_type?.split(",");
      }
      this.ensureDefaultContactTypes();
    },
    onContactTypeChange(contact, index) {
      const message = onAttorneyContactCategoryChange(
        this.form.contacts,
        contact,
        index
      );
      if (message) {
        this.contactCategoryErrors = {
          ...this.contactCategoryErrors,
          [index]: message,
        };
        if (this.$toast) {
          this.$toast.error(message);
        }
      } else {
        const nextErrors = { ...this.contactCategoryErrors };
        delete nextErrors[index];
        this.contactCategoryErrors = nextErrors;
        this.form.contacts = sortContactsPrimaryFirst(this.form.contacts);
        this.v$.$reset();
      }
    },
    formatPhoneUS(phone) {
      // remove everything except digits
      let digits = ('' + phone).replace(/\D/g, '');

      // remove leading country code (+1)
      if (digits.length > 10 && digits.startsWith('1')) {
        digits = digits.slice(1);
      }

      // pad with zeros if less than 10
      while (digits.length < 10) {
        digits = digits + "0";
      }

      // only take first 10 digits
      digits = digits.slice(0, 10);

      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    },
    //After select address, autofill city,state,county, zip from address
    getAddressComponent(addressComponents, type) {
      const component = addressComponents.find((comp) =>
        comp.types.includes(type)
      );
      return component ? component.long_name : null;
    },
    getAddressData: function (addressData, field, index) {
      
      this.$nextTick(() => {
        const addressRef = this.$refs["address_" + index];
        let autocompleteText = "";

        if (Array.isArray(addressRef)) {
          autocompleteText = addressRef[0]?.autocompleteText || "";
        } else {
          autocompleteText = addressRef?.autocompleteText || "";
        }

        // Split into comma-separated parts
        const parts = autocompleteText.split(",").map(part => part.trim());

        // Remove last 2–3 parts (country, state, city)
        const cleanedParts = parts.slice(0, parts.length - 3);

        // Fallback: If removing 3 parts leaves nothing, use first 2
        const addressLine1 =
          cleanedParts.length > 0 ? cleanedParts.join(", ") : parts.slice(0, 2).join(", ");

        // ✅ Set final address1
        this.form.addresses[index].address1 = addressLine1;

        // Clear address2
        this.form.addresses[index].address2 = "";

        // Structured fields
        this.form.addresses[index].city = addressData.locality || addressData.city || "";
        this.form.addresses[index].state = addressData.administrative_area_level_1 || addressData.state || "";
        this.form.addresses[index].zip = addressData.postal_code || "";
        this.form.addresses[index].county = addressData.administrative_area_level_2 || "";

        const countryText = addressData.country;
        this.form.addresses[index].country =
          typeof countryText === "string" && countryText.length > 1 && countryText !== "0"
            ? countryText
            : "United States";

        if (!this.form.addresses[index].county) {
          this.$store
            .dispatch("getAddressCounty", {
              zip: this.form.addresses[index].zip,
              city: this.form.addresses[index].city,
              state: this.form.addresses[index].state,
            })
            .then(() => {
              this.form.addresses[index].county = this.address_county;
            });
        }
      });
    },

    // filter data in autocomplete dropdown
    onSalutationChange(event) {
      const name = event.target.value;
      const found = this.salutations.find((item) => item.name === name);
      this.form.salutation = found || name || "";
    },
    searchAutocomplete: function (event, field) {
      if (field == "salutation") {
        if (!event.query.trim().length) {
          this.salutations = [...this.salutations];
        } else {
          this.salutations = this.salutations.filter((item) => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      } else if (field == "infoTypes") {
        if (!event.query.trim().length) {
          this.infoTypes = [...this.infoTypes];
        } else {
          this.infoTypes = this.infoTypes.filter((item) => {
            return item.name
              .toLowerCase()
              .startsWith(event.query.toLowerCase());
          });
        }
      }
    },
    // add more contact
    add_contact: function () {
      this.form.contacts.push(createEmptyContact());
      this.v$.$reset();
    },
    getCountry: function (index) {
      this.$store.dispatch("getAddressCounty", {
        zip: this.form.addresses[index].zip,
        city: this.form.addresses[index].city,
        state: this.form.addresses[index].state,
      });
      setTimeout(() => {
        this.form.addresses[index].county = this.address_county;
      }, 1100);
    },
    //add more address
    add_address: function () {
      this.form.addresses.push({
        type: { id: 1, name: "SECONDARY" },
        address1: "",
        address2: "",
        city: "",
        state: "",
        country: "",
        county: "",
        zip: "",
      });
      this.v$.$touch();
      console.log(this.v$.form.addresses[0].address1);
      if (this.v$.$invalid) return;
    },
    // Open confirmation popup for delete address
    ConfirmDelete: function (index) {
      this.showDeleteModal = true;
      this.deleteIndex = index;
    },
    // Open confirmation popup for delete contact
    ConfirmContactDelete: function (index) {
      this.showContactDeleteModal = true;
      this.deleteContactIndex = index;
    },
    // On cancel in popup
    cancelModal: function () {
      this.showDeleteModal = false;
      this.showContactDeleteModal = false;
    },
    // remove address from address array
    remove_address: function () {
      if (
        this.form.addresses[this.deleteIndex + 1]?.address1 != undefined &&
        this.form.addresses[this.deleteIndex + 1]?.address1 != null
      ) {
        if (this.$refs["address_" + this.deleteIndex].update) {
          this.$refs["address_" + this.deleteIndex].update(
            this.form.addresses[this.deleteIndex + 1].address1
          );
        } else if (this.$refs["address_" + this.deleteIndex][0].update) {
          this.$refs["address_" + this.deleteIndex].update(
            this.form.addresses[this.deleteIndex + 1][0].address1
          );
        }
      } else {
        if (this.$refs["address_" + this.deleteIndex].clear) {
          this.$refs["address_" + this.deleteIndex].clear();
        } else if (this.$refs["address_" + this.deleteIndex][0].update) {
          this.$refs["address_" + this.deleteIndex][0].clear();
        }
      }
      this.form.addresses.splice(this.deleteIndex, 1);
      this.showDeleteModal = false;
    },
    // remove contact from contact array
    remove_contact: function () {
      this.form.contacts.splice(this.deleteContactIndex, 1);
      this.showContactDeleteModal = false;
    },
    //submit primary step and validate form
    submitApplication: function () {
      const categoryError = validateAttorneyContactCategories(
        this.form.contacts
      );
      if (categoryError) {
        if (this.$toast) {
          this.$toast.error(categoryError);
        }
        return;
      }
      this.v$.form.$touch();
      if (this.v$.form.$pending || this.v$.form.$error) return;
    },
    prepareContactsForSubmit() {
      const categoryError = validateAttorneyContactCategories(
        this.form.contacts
      );
      if (categoryError) {
        if (this.$toast) {
          this.$toast.error(categoryError);
        }
        return false;
      }
      this.form.contacts = prepareContactsForSave(this.form.contacts);
      return true;
    },
  },
};
</script>
